import React from 'react'
import FormatCurrency from 'components/Common/FormatCurrency'
import LinePlaneFlyIcon from 'components/Luxkit/Icons/line/LinePlaneFlyIcon'
import { getDefaultAirportCode } from 'selectors/flightsSelectors'
import { connect } from 'react-redux'
import Caption from 'components/Luxkit/Typography/Caption'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { getBundledWithFlightOfferDisplayPricing } from 'lib/getOfferDisplayPricing'
import CaptionTextBlock from 'components/Luxkit/TextBlocks/CaptionTextBlock'
import Group from 'components/utils/Group'

interface Props {
  airportCode: string
  bundledWithFlightsOnly: boolean;
  flightPrices: { [airportCode: string]: number };
  price: number
  value?: number
  duration: string
}

function BundledHotelPriceContent({
  airportCode,
  bundledWithFlightsOnly,
  flightPrices,
  price,
  value,
  duration,
}: Props) {
  const flightPrice = flightPrices[airportCode]

  const result = getBundledWithFlightOfferDisplayPricing(bundledWithFlightsOnly, flightPrice, price, value ?? price)

  if (result.isBundledFlightPriceDisplayable && result.totalPrice) {
    const { totalPrice, flightPrice } = result
    return (
      <Group direction="vertical" gap={4}>
        <CaptionTextBlock variant="medium" weight="bold" startIcon={<LinePlaneFlyIcon />}>
          {duration}{flightPrice && ' + flights from'}
        </CaptionTextBlock>
        <Caption variant="medium">
          <BodyText variant="large" weight="bold">
            <FormatCurrency value={Math.ceil(totalPrice)} />
          </BodyText>
          {' total*'}
        </Caption>
      </Group>
    )
  }

  return (
    <CaptionTextBlock variant="medium" weight="bold" startIcon={<LinePlaneFlyIcon />}>
      Hotel + flight package available
    </CaptionTextBlock>
  )
}

function mapStateToProps(state: App.State) {
  return {
    airportCode: getDefaultAirportCode(state),
  }
}

export default connect(mapStateToProps)(BundledHotelPriceContent)
